module.exports = __webpack_public_path__ + "media/public/img/tripadvisor-review-widget-01-be87b714ce2580b9709359a26da6811e.svg";